import * as pages from './page-names';

export const homeRoute = '/' + pages.homePageName;
export const changePasswordRoute = '/' + pages.changePasswordPageName;
export const forgotPasswordRoute = '/' + pages.forgotPasswordPageName;
export const registerRoute = '/' + pages.registerPageName;
export const editProfileRoute = '/' + pages.editProfilePageName;
export const loginRoute = '/' + pages.loginPageName;
export const userEditRoute = '/' + pages.userEditPageName;
export const twoFactorAuthenticationRoute = '/' + pages.twoFactorAuthenticationPageName;
export const twoFactorAuthenticationRegistrationRoute = twoFactorAuthenticationRoute + '/' + pages.registrationPageName;
export const twoFactorAuthenticationRecoveryRoute = twoFactorAuthenticationRoute + '/' + pages.recoveryPageName;


export const adminRoute = '/' + pages.adminPageName;
export const clientAdministrationRoute = adminRoute + '/' + pages.clientAdministrationPageName;
export const userManagementRoute = adminRoute + '/' + pages.userManagementPageName;
export const configurationAdministrationRoute = adminRoute + '/' + pages.configurationAdministrationPageName;
export const companyAdministrationRoute = adminRoute + '/' + pages.companyAdministrationPageName;
export const parkerAdministrationRoute = adminRoute + '/' + pages.parkerAdministrationPageName;
export const fleetListAdministrationRoute = adminRoute + '/' + pages.fleetListAdministrationPageName;
export const tagsAdministrationRoute = adminRoute + '/' + pages.tagsAdministrationPageName;
export const onBoardingWizardRoute = adminRoute + '/' +  pages.onBoardingWizardPageName;
export const tagMasterRoute = adminRoute + '/' +  pages.tagMasterPageName;
export const thirdPartyUserZoneAssignmentAdministrationRoute = adminRoute + '/' + pages.thirdPartyUserZoneAssignmentAdministrationPageName;
export const parkingRangerZoneAssignmentAdministrationRoute = adminRoute + '/' + pages.parkingRangerZoneAssignmentAdministrationPageName;

export const parkRoute = '/' + pages.parkPageName;
export const parkingRoute = parkRoute + '/' + pages.parkingPageName;
export const automaticParkingRoute = parkRoute + '/' + pages.automaticParkingPageName;
export const parkerRegistrationRoute = parkRoute + '/' + pages.parkerRegistrationsPageName;
export const parkingRangerSessionsRoute = parkRoute + '/' + pages.parkingRangerSessionsPageName;
export const zoneDamageRoute = parkRoute + '/' + pages.zoneDamagePageName;
export const deviceInteractionRoute = parkRoute + '/' + pages.deviceInteractionPageName;
export const parkingCardRoute = parkRoute + '/' + pages.parkingCardPageName;
export const parkingCardAdminRoute = parkRoute + '/' + pages.parkingCardAdminPageName;

export const reportsRoute = '/' + pages.reportsPageName;
export const savedReportsRoute = '/' + pages.reportsPageName + '/' + pages.savedReportsPageName;
export const tagsPerParkerRoute = '/' + pages.reportsPageName + '/' + pages.tagsPerParkerPageName;
export const parkerRegistrationsRoute = '/' + pages.reportsPageName + '/' + pages.parkerRegistrationsPageName;
export const falseRecordingsRoute = '/' + pages.reportsPageName + '/' + pages.falseRecordingsPageName;
export const parkerTurnoverRoute = '/' + pages.reportsPageName + '/' + pages.parkerTurnoverPageName;
export const parkerExtractRoute = '/' + pages.reportsPageName + '/' + pages.parkerExtractPageName;
// export const iamReportWithTagInformationRoute = '/' + pages.reportsPageName + '/' + pages.iamReportWithTagInformationPageName;
export const deviceStatusRoute = '/' + pages.reportsPageName + '/' + pages.deviceStatusPageName;
// export const parkerPerTariffRoute = '/' + pages.reportsPageName + '/' + pages.parkerPerTariffPageName;
// export const parkerUtilizationRoute = '/' + pages.reportsPageName + '/' + pages.parkerUtilizationPageName;
export const automaticParkingReportRoute = '/' + pages.reportsPageName + '/' + pages.automaticParkingPageName;
export const paymentReportRoute = '/' + pages.reportsPageName + '/' + pages.paymentPageName;
export const userExtractRoute = '/' + pages.reportsPageName + '/' + pages.userExtractPageName;
export const exportJobsRoute = '/' + pages.reportsPageName + '/' + pages.exportJobsPageName;
export const exportJobsCreateRoute = exportJobsRoute + '/' + pages.exportJobsCreatePageName;

export const fastCheckinRoute = '/' + pages.fastCheckinPageName;
export const payTillNowRoute = '/' + pages.payTillNowPageName;
export const mobileLandingRoute = '/' + pages.mobileLandingPageName;

export const problemReportAdministrationRoute = adminRoute + '/' + pages.problemReportAdministrationPageName;
